export default {
  "enfis": {
    "modules": {
      "user": {
        "permissionDenied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadne, alebo nedostatočné prístupové práva!"])}
      }
    }
  },
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])}
}